
export default (refreshType) => {
  const INITIAL_STATE = null;

  return (state = INITIAL_STATE, action) => {
    switch(action.type) {
      case refreshType:
        return new Date();

      default:
        return state;
    }
  };
};



/** WEBPACK FOOTER **
 ** ./src/members/state/__shared__/reducersMakers/lastTimeRefreshMaker.js
 **/